import React, { useState } from 'react';
import axios from 'axios';
import './App.css';
import styled from "styled-components";

const Container = styled.div`
    max-width: 100vh;
    margin: 50px auto;
    padding: 20px;
    box-shadow: 0 0 10px rgba(169, 169, 169, 1.0);
    border-radius: 10px;
    text-align: center; /* Centrar contenido */
`;

const Button = styled.button`
    padding: 10px 15px;
    font-size: 16px;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    width: 100%;
    max-width: 200px;
    &:disabled {
        background-color: #cccccc;
    }
`;

const ProgressBar = styled.div`
    width: 100%;
    background-color: #efefef;
    border-radius: 5px;
    overflow: hidden;
    margin-top: 20px;
    margin-bottom: 30px;

    .progress-bar {
        height: 10px;
        background-color: #007bff;
        width: 0;
        transition: width 0.4s ease;
    }
`;

const Header = styled.header`
    margin-bottom: 20px;
    margin-top: 20px;
`;

const SpeedText = styled.h2`
    font-size: 18px;
    color: #787878;
    margin-top: 30px;
    margin-bottom: 30px;
    text-transform: capitalize;
`;

const App = () => {
    const [downloadSpeed, setDownloadSpeed] = useState(null);
    const [uploadSpeed, setUploadSpeed] = useState(null);
    const [ping, setPing] = useState(null);
    const [progress, setProgress] = useState(0);
    const [isTesting, setIsTesting] = useState(false);

    const startPingTest = async () => {
        const startTime = new Date().getTime();
        try {
            await axios.get('https://click.com.ar/testvelocidad/ping.php');
            const endTime = new Date().getTime();
            const latency = endTime - startTime; // en milisegundos
            setPing(latency);
        } catch (error) {
            console.error('Error measuring ping:', error);
            setPing('Error');
        }
    };

    const startDownloadTest = async () => {
        setIsTesting(true);
        setProgress(0);
        setDownloadSpeed(null);
        setUploadSpeed(null);
        setPing(null);

        await startPingTest();

        const startTime = new Date().getTime();
        const url = 'https://click.com.ar/testvelocidad/speedtest-file.php';

        try {
            const response = await axios.get(url, {
                responseType: 'blob',
                onDownloadProgress: (progressEvent) => {
                    if (progressEvent.lengthComputable) {
                        const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setProgress(percentage);
                    }
                },
            });

            const endTime = new Date().getTime();
            const duration = (endTime - startTime) / 1000; // en segundos
            const fileSize = response.data.size * 8; // en bits
            const speedMbps = (fileSize / duration / 1024 / 1024).toFixed(2); // en Mbps

            setDownloadSpeed(speedMbps);
        } catch (error) {
            console.error('Error downloading the file:', error);
            setDownloadSpeed('Error');
        }

        setIsTesting(false);
    };

    const startUploadTest = async () => {
        setIsTesting(true);
        setProgress(0);

        const dummyData = new Blob([new Array(10 * 1024 * 1024).join('a')], { type: 'application/octet-stream' }); // 10 MB de datos
        const formData = new FormData();
        formData.append('file', dummyData, 'dummy.zip');
        formData.append('startTime', microtime(true));

        try {
            const response = await axios.post('https://click.com.ar/testvelocidad/upload-test.php', formData, {
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.lengthComputable) {
                        const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setProgress(percentage);
                    }
                },
            });

            const speedMbps = response.data.speed.toFixed(2); // en Mbps
            setUploadSpeed(speedMbps);
        } catch (error) {
            console.error('Error uploading the file:', error);
            setUploadSpeed('Error');
        }

        setIsTesting(false);
    };


    const startTest = async () => {
        await startDownloadTest();
        await startUploadTest();
    };

    return (
        <Container>
            <Header>
                <ProgressBar>
                    <div className="progress-bar" style={{ width: `${progress}%` }}></div>
                </ProgressBar>
                <Button onClick={startTest} disabled={isTesting}>
                    {isTesting ? 'Test en curso ... ' : 'Iniciar Prueba'}
                </Button>
                {ping !== null && <SpeedText>Ping: {ping} ms</SpeedText>}
                {downloadSpeed && <SpeedText>Velocidad de descarga: {downloadSpeed} Mbps</SpeedText>}
                {uploadSpeed && <SpeedText>Velocidad de subida: {uploadSpeed} Mbps</SpeedText>}
            </Header>
        </Container>
    );
};

export default App;

function microtime(get_as_float) {
    var now = Date.now() / 1000;
    var s = parseInt(now, 10);

    return get_as_float ? now : (Math.round((now - s) * 1000) / 1000) + ' ' + s;
}

